import type { AssistantNavigationLocation } from "@/lib/ai/assistant-v2/navigation";

export type AssistantV2ClientEvent = {
    type: "navigation";
    text: string;
    locations: AssistantNavigationLocation[];
};

export interface AssistantV2ClientEventDependencies {
    appendFinalText: (text: string) => void;
    appendError: (message: string) => void;
    navigate: (href: string) => void;
}

export type AssistantV2ClientEventResult = { kind: "handled" };

/** Applies deterministic, server-resolved V2 navigation only. */
export function applyAssistantV2ClientEvent(
    event: AssistantV2ClientEvent,
    dependencies: AssistantV2ClientEventDependencies,
): AssistantV2ClientEventResult {
    const [location] = event.locations;
    if (!location) {
        dependencies.appendError("That Iloris destination is unavailable.");
        return { kind: "handled" };
    }
    dependencies.appendFinalText(event.text);
    dependencies.navigate(location.href);
    return { kind: "handled" };
}
